import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-bar-content",class:_vm.containerClass},[_c(VCard,{attrs:{"id":"appsideBar","tile":true,"color":"surface lighten-1"}},[_c('keep-alive',[_c(_vm.currentSideBar,{tag:"component",staticClass:"side-bar-component"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }